var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3503 5.27801C16.7593 5.66014 16.7731 6.29316 16.3812 6.69191L8.51795 14.6919C8.32713 14.8861 8.06414 14.9971 7.78836 14.9999C7.51258 15.0028 7.24723 14.8973 7.05221 14.7071L3.63341 11.3738C3.23287 10.9832 3.23287 10.3501 3.63341 9.95956C4.03395 9.56904 4.68335 9.56904 5.08389 9.95956L7.76186 12.5706L14.9002 5.3081C15.2921 4.90935 15.9414 4.89588 16.3503 5.27801Z",
    fill: "#386BFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    stroke: "#386BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.be67ae9e6ed5beffeb1dfd37ede72a6b.svg";
export { ForwardRef as ReactComponent };